import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Mic, TrendingUp, BookOpen, Trophy, Smile, Settings, LogOut } from 'lucide-react';
import { Separator } from '../ui/separator';
import useAuthStore from '../../stores/authStore';
import BotViewLogo from '../ui-kit/BotViewLogo';
import { TEST_IDS } from '../../constants/testIds';

const mainNav = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard', testId: TEST_IDS.NAV_DASHBOARD },
  { to: '/interviews', icon: Mic, label: 'Interview', testId: TEST_IDS.NAV_INTERVIEWS },
  { to: '/progress', icon: TrendingUp, label: 'Insight', testId: TEST_IDS.NAV_PROGRESS },
  { to: '/knowledge', icon: BookOpen, label: 'Knowledge', testId: TEST_IDS.NAV_KNOWLEDGE },
  { to: '/leaderboard', icon: Trophy, label: 'Leaderboard', testId: TEST_IDS.NAV_LEADERBOARD },
  { to: '/sentiment', icon: Smile, label: 'Sentiment', testId: TEST_IDS.NAV_SENTIMENT },
];

const generalNav = [
  { to: '/settings', icon: Settings, label: 'Settings', testId: TEST_IDS.NAV_SETTINGS },
];

function NavItem({ item }) {
  return (
    <NavLink
      to={item.to}
      end={item.to === '/'}
      data-testid={item.testId}
      className={({ isActive }) =>
        `flex items-center gap-3 px-3.5 py-2.5 rounded-lg text-[13px] font-medium transition-all duration-200
         ${isActive
           ? 'bg-[#3D1F6E] text-white shadow-sm'
           : 'text-muted-foreground hover:text-foreground hover:bg-secondary/60'
         }`
      }
    >
      <item.icon className="w-[18px] h-[18px] shrink-0" />
      <span>{item.label}</span>
    </NavLink>
  );
}

export default function Sidebar() {
  const { logout } = useAuthStore();

  return (
    <aside
      data-testid={TEST_IDS.SIDEBAR}
      className="hidden md:flex md:flex-col w-[280px] fixed inset-y-0 left-0
                 bg-card border-r border-border z-30"
    >
      {/* Brand */}
      <div className="flex items-center gap-2.5 px-6 h-16 shrink-0">
        <BotViewLogo size={32} className="shrink-0" />
        <span className="text-[15px] font-bold tracking-tight font-heading">BotView</span>
      </div>

      <Separator />

      {/* Main menu */}
      <div className="flex-1 overflow-y-auto py-5 px-4">
        <p className="px-3 mb-2 text-[10px] font-heading uppercase tracking-[0.2em] text-muted-foreground font-semibold">
          Main Menu
        </p>
        <nav className="space-y-1">
          {mainNav.map((item) => <NavItem key={item.to} item={item} />)}
        </nav>

        <p className="px-3 mt-6 mb-2 text-[10px] font-heading uppercase tracking-[0.2em] text-muted-foreground font-semibold">
          General
        </p>
        <nav className="space-y-1">
          {generalNav.map((item) => <NavItem key={item.to} item={item} />)}
        </nav>
      </div>

      {/* Footer */}
      <div className="px-4 pb-4">
        <button
          data-testid={TEST_IDS.LOGOUT_BTN}
          onClick={logout}
          className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-[13px] font-medium
                     text-muted-foreground hover:text-destructive hover:bg-destructive/10 transition-colors"
        >
          <LogOut className="w-[18px] h-[18px]" />
          <span>Log Out</span>
        </button>
      </div>
    </aside>
  );
}
